<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 15.997a.626.626 0 0 1-.219-.04l-1.092-.408A10.473 10.473 0 0 1 3.682 13.8a7.605 7.605 0 0 1-1.915-2.393l-.113-.221a8.275 8.275 0 0 1-.806-2.458A26.173 26.173 0 0 1 .5 4.497v-.788a1 1 0 0 1 .616-.934L7.764.046a.636.636 0 0 1 .474 0l6.646 2.732c.375.158.618.525.616.932v1.144c.002 1.37-.118 2.74-.357 4.089a7.379 7.379 0 0 1-.7 2.074l-.2.392a7.6 7.6 0 0 1-1.915 2.393 10.41 10.41 0 0 1-3.009 1.749l-1.09.408a.626.626 0 0 1-.229.038ZM6.22 8.072l1.2 1.2a2.752 2.752 0 0 0 2.321 4.223 2.752 2.752 0 0 0 2.75-2.749 2.754 2.754 0 0 0-4.224-2.323l-1.2-1.2a2.753 2.753 0 0 0-2.321-4.222 2.754 2.754 0 0 0-2.75 2.75A2.753 2.753 0 0 0 6.22 8.073l.001-.001Z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering142',
});
</script>
